/**
 * Review bar (sections/review-bar.liquid)
 * Replaces the fallback rating and count with the live totals from the Reviews.io public API
 * once the page has loaded. Requests a single review, since only the totals are needed; the
 * browser caches the response for 2 hours.
 */
if (!customElements.get("review-bar")) {
  customElements.define(
    "review-bar",
    class ReviewBar extends HTMLElement {
      static API = "https://api.reviews.io/timeline/data";

      connectedCallback() {
        if (this.requested) return;
        this.requested = true;
        const start = () => ("requestIdleCallback" in window ? requestIdleCallback(() => this.load()) : setTimeout(() => this.load(), 200));
        if (document.readyState === "complete") start();
        else window.addEventListener("load", start, { once: true });
      }

      async load() {
        const params = new URLSearchParams({
          type: "store_review",
          store: this.dataset.store,
          per_page: "1",
          include_local_reviews: "1",
        });
        try {
          const response = await fetch(`${ReviewBar.API}?${params}`);
          if (!response.ok) return;
          const { stats } = await response.json();
          const rating = parseFloat(stats && stats.average_rating);
          const count = parseInt(stats && stats.review_count, 10);
          if (!rating || !count) return;
          this.update(rating, count);
        } catch (error) {
          // Keep the fallback figures.
        }
      }

      update(rating, count) {
        const locale = document.documentElement.lang || "en";
        this.querySelector("[data-text]").textContent = this.dataset.template
          .replace("[rating]", rating.toFixed(2))
          .replace("[count]", new Intl.NumberFormat(locale).format(count));

        // Same rounding as snippets/rating.liquid: a half star between .3 and .7.
        const stars = this.querySelector("[data-stars] .rating");
        if (!stars) return;
        let full = Math.floor(rating);
        const fraction = rating - full;
        let half = false;
        if (fraction >= 0.7) full += 1;
        else if (fraction > 0.3) half = true;
        stars.replaceChildren();
        for (let i = 0; i < 5; i++) {
          const kind = i < full ? "full" : i === full && half ? "half" : "empty";
          stars.append(this.querySelector(`template[data-star-${kind}]`).content.cloneNode(true));
        }
      }
    },
  );
}
